module.exports = __webpack_public_path__ + "img/career-2-unlock-your-potential.f045ea78.jpg";